import {SET_MAP_POSITION} from './types';

const setMapPosition = position => ({
  type: SET_MAP_POSITION,
  position,
});

export default setMapPosition;
